export type CardVariantT = 'base' | 'highlight' | 'office' | 'clickable' | 'disabled'

export const cardVariants: Record<CardVariantT, CardVariantT> = {
  highlight: 'highlight',
  office: 'office',
  clickable: 'clickable',
  base: 'base',
  disabled: 'disabled',
}
